import { isEmpty, omitBy } from 'lodash-es'

const removeEmpty = <T extends object>(params: T): Partial<T> => {
  return omitBy<T>(params, isEmpty)
}

export default removeEmpty
